import { render, staticRenderFns } from "./EditarObito.vue?vue&type=template&id=5ee5b1a6&"
import script from "./EditarObito.vue?vue&type=script&lang=js&"
export * from "./EditarObito.vue?vue&type=script&lang=js&"
import style0 from "./EditarObito.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports